import { render, staticRenderFns } from "./InvoiceTitle.vue?vue&type=template&id=4482638f&scoped=true&"
import script from "./InvoiceTitle.vue?vue&type=script&lang=js&"
export * from "./InvoiceTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4482638f",
  null
  
)

component.options.__file = "InvoiceTitle.vue"
export default component.exports